import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

import { clearSignedInMarker, trackSignedOut } from '@/analytics/events';
import { resetPostHog } from '@/analytics/posthog';

// v2 of the Auth0 SDK moved the post-logout redirect target under
// `logoutParams.returnTo` (see RFC 006 §Auth0 SDK). The URL must match an
// Allowed Logout URL on the SPA Application in the Auth0 dashboard.
export function useLogout(): () => Promise<void> {
  const { logout } = useAuth0();
  return useCallback(() => {
    // Emit the intent before resetting identity, then reset before the
    // redirect so the next person who logs in on this browser starts a
    // fresh PostHog identity (no event merging). Both no-op when PostHog
    // is unconfigured. Clear the once-per-session `signed_in` marker so a
    // re-login in the same tab fires `signed_in` again.
    trackSignedOut();
    clearSignedInMarker();
    resetPostHog();
    return logout({ logoutParams: { returnTo: window.location.origin } });
  }, [logout]);
}
